export function truncate(string, length) {
  if (string && string.length > length) {
    return `${string.substring(0, length - 2)}...`
  } else {
    return string
  }
}

export function getActionText(action, releaseDate) {
  if (action === 'save-media' || action === 'create-playlist') {
    return 'Save'
  } else if (action === 'follow') {
    return 'Follow'
  } else if (action === 'presave') {
    // Change text after album release
    const today = new Date()
    const release_date = new Date(releaseDate)
    if (today <= release_date) {
      return 'Pre-save';
    } else {
      return 'Save';
    }
  }
}

export async function getMedia(project_id, service_id) {
  try {
    const base_url = window.location.href.includes('localhost:3000') ? 'https://wayward.ngrok.io' : 'https://api.sonikit.com';
    const response = await fetch(`${base_url}/services/${service_id}/media`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${project_id}`
      }
    })

    if (!response.ok) return { error: 'Unable to get media'}
    const data = await response.json();
    return data;
  } catch (error) {
    return { error: 'Unable to get media'}
  }
}

export function getFlagUrl(countryCode) {
  return `http://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode}.svg`
}